'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('TranslationOrderUpload', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'FileUploader',
	'Authentication',
	'$state',
	'EntryMain',
	function (
		$rootScope,
		$scope,
		$stateParams,
		FileUploader,
		Authentication,
		$state,
		EntryMain
	) {
		$scope.authentication = Authentication;
		$scope.mobileAppId = $stateParams.mobileAppId;
		$scope.errorMessage = '';

		$scope.allowedFileTypes = ['xls', 'xlsx'];


		/**
		 * Initializes the uploader data
		 */
		function initUploader() {

			var uploader = $scope.uploader = new FileUploader({
				url: '/v1/orders/app/'+ $stateParams.mobileAppId + '/translationOrderUpload'
			});

			// FILTERS
			uploader.filters.push({
				name: 'imageFilter',
				fn: function(item) {
					var type = item.name.slice(item.name.lastIndexOf('.') + 1);
					console.log('type: ' + type);
					return $scope.allowedFileTypes.indexOf(type) !== -1;
				}
			});

			// CALLBACKS
			uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
				console.info('onWhenAddingFileFailed', item, filter, options);
				$scope.errorMessage = 'The file you tried to upload is currently not supported. Please upload files of the following types: "' + $scope.allowedFileTypes.join('", "') + '"';

			};
			uploader.onAfterAddingFile = function(fileItem) {
				uploader.uploadAll();
			};
			uploader.onSuccessItem = function(fileItem, response, status, headers) {
				// All seems fine so redirect to the page where user can select
				// which column represents what data.
				$state.go('translationOrderSelect', {mobileAppId: $stateParams.mobileAppId, fileData: response});
			};
			uploader.onErrorItem = function(fileItem, response, status, headers) {
				if (response.hasOwnProperty('message')) {
					$scope.errorMessage = response.message;
				} else {
					$scope.errorMessage = 'There was a problem with your file. Please try again. If that problem reappears please contact support.';
				}
			};
		}


		$scope.tryAgain = function() {
			$scope.errorMessage = '';
			initUploader();
		};


		$scope.cancel = function() {
			$state.go('listMobileApps');
		};


		function init() {
			// Get the app data
			EntryMain.loadMobileApp($scope.mobileAppId, false, function(err, mobileApp) {
				$scope.mobileApp = mobileApp;
				console.log(mobileApp);
			});

			initUploader();
		}


		init();
	}
]);
